var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-file-input',{ref:"fileUpload",attrs:{"label":'Upload ' + _vm.name,"type":"file","accept":".pdf,.jpg,.jpeg,.png","loading":_vm.loading,"rules":_vm.rules},on:{"change":_vm.handleImage}}),_c('small',{staticClass:"tw-w-full tw-p-2"},[_vm._v("maximum of "+_vm._s(_vm.size)+" MB. Supports PDF, JPEG, and PNG files")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }